<template>
  <div class="whs-detail-slider" ref="sliderContainer">
    <div class="whs-detail-slider-inner">
      <div class="whs-slider-inline" :style="{width: thumbsWidth, left: thumbsPosition}">
        <div
          class="whs-slider-inline-thumb"
          v-for="(image, index) in images"
          :key="image.url"
          @click="toggleFullscreen(index)"
        >
          <img class="whs-slider-inline-thumb-image" :src="image.url" alt="Фотография отеля">
        </div>
      </div>
      <div class="whs-slider-inline-left whs-icon" @click="thumbLeft" v-show="currentThumb"></div>
      <div class="whs-slider-inline-right whs-icon" @click="thumbRight" v-show="thumbsHaveSpace"></div>
    </div>

    <FullscreenGallery
      :images="images"
      :fullscreen="fullscreen"
      :toggleFullscreen="toggleFullscreen"
      :initSlide="currentSlide"
      :getImage="getFullscreenImage"
    />
  </div>
</template>

<script>
import FullscreenGallery from '../components/FullscreenGallery.vue';

export default {
  name: 'Slider',
  props: {
    images: {
      type: Array,
      required: true
    }
  },
  components: {
    FullscreenGallery
  },
  data: function() {
    return {
      currentSlide: 0,
      currentThumb: 0,
      fullscreen: false,
      thumbsHaveSpace: true
    };
  },
  watch: {
    currentThumb: function(num) {
      if (this.$refs.sliderContainer)
        this.thumbsHaveSpace =
          this.$refs.sliderContainer.offsetWidth + num * 122 <=
          Math.ceil(this.images.length / 2) * 122;
    }
  },
  computed: {
    // thumbsHaveSpace: {
    //   get() {
    //     return (
    //       this.$refs.sliderContainer.offsetWidth + this.currentThumb * 122 <=
    //       Math.ceil(this.images.length / 2) * 122
    //     );
    //   }
    // },
    thumbsOnScreen: {
      get() {
        return Math.floor(this.$refs.sliderContainer.offsetWidth / 122);
      }
    },
    thumbsWidth: {
      get() {
        return Math.ceil(this.images.length / 2) * 122 + 'px';
      }
    },
    thumbsPosition: {
      get() {
        return this.currentThumb * -122 + 'px';
      }
    }
  },
  methods: {
    toggleFullscreen(index = false) {
      if (index === false) {
        this.fullscreen = false;
        // document.body.style;
      } else {
        this.fullscreen = true;
        this.currentSlide = index;
      }
    },
    thumbRight() {
      this.currentThumb++;
    },
    thumbLeft() {
      if (this.currentThumb <= 0) return;
      this.currentThumb--;
    },
    getFullscreenImage(num) {
      return this.images[num].orig_url;
    }
  }
};
</script>

<style scoped>
.whs-detail-slider {
  width: 100%;
  background: #fff;
  user-select: none;
}
.whs-detail-slider-inner {
  display: flex;
  position: relative;
  width: 100%;
  height: 244px;
  overflow: hidden;
}
.whs-slider-inline {
  display: flex;
  flex-wrap: wrap;
  position: absolute;
  transition: 0.3s;
}
.whs-slider-inline-thumb {
  margin: 1px;
  flex: 1 1 120px;
  max-width: 120px;
  /* width: 144px; */
  height: 120px;
  overflow: hidden;
  cursor: pointer;
}
.whs-slider-inline-thumb-image {
  max-width: 100%;
  height: 100%;
  width: 100%;
  object-fit: cover;
}
.whs-slider-inline-left,
.whs-slider-inline-right {
  position: absolute;
  z-index: 1;
  left: 0;
  bottom: 0;
  height: 32px;
  width: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: var(--color-bg);
  cursor: pointer;
}
.whs-slider-inline-right {
  right: 0;
  left: unset;
}
.whs-slider-inline-left:before,
.whs-slider-inline-right:before {
  width: 100%;
  text-align: center;
  content: '\f054';
  font-size: 18px;
  color: var(--color-main);
}
.whs-slider-inline-left:before {
  content: '\f053';
}
.whs-slider-fullscreen {
  z-index: 9000;
  position: fixed;
  display: flex;
  flex-direction: column;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  background-color: var(--color-text-5);
  align-items: center;
  justify-content: center;
}
</style>